import { useQuery } from '@tanstack/react-query'

import { apiGetSealedOrderAvailability } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

/**
 * 밀봉비닐 신청 가능 여부 — GET /product-orders/availability.
 *
 * 진입 분기용. 활성 주문 / 재고 / 정책 등을 백엔드가 종합 판단해 boolean 으로 응답.
 * 매 진입마다 최신 상태가 필요하므로 staleTime 0.
 */
export const useGetSealedOrderAvailability = () =>
  useQuery({
    queryKey: [PAYMENT_KEYS.SEALED_ORDER_AVAILABILITY],
    queryFn: apiGetSealedOrderAvailability,
    staleTime: 0,
  })
